function Collection() {
    this.Title = "";
    this.Nodes = [];
}
if (typeof exports !== 'undefined') {
    module.exports = Collection;
}